import { IAmendOrderFromAnotherUserService } from './amend-order-from-another-user.interface';
import { injectable } from 'inversify';
import { IPendingOrderReport } from '../../interfaces';
import { Observable, Subject } from 'rxjs';

@injectable()
export class AmendOrderFromAnotherUserMock implements IAmendOrderFromAnotherUserService {
    asObservable(): Observable<IPendingOrderReport> {
        return (new Subject<IPendingOrderReport>()).asObservable();
    }
}
